import { isElectronRuntime } from './realm/isRealmEnabled';

/**
 * Forward UI errors / key chat actions into the Electron log file
 * (~/Library/Application Support/workloop-desktop/logs/workloop.log on Mac,
 * %APPDATA%\\workloop-desktop\\logs\\workloop.log on Windows).
 */
export const initDesktopFileLogging = () => {
  if (typeof window === 'undefined' || !isElectronRuntime()) return;
  const api = window.workloopRealm;
  if (!api?.log) return;

  const log = (level, message, extra) => {
    try {
      api.log(level, message, extra);
    } catch {
      // ignore
    }
  };

  log('info', 'UI logging attached', { href: window.location.href });

  window.addEventListener('error', (event) => {
    log('error', `React/UI error: ${event?.message || 'unknown'}`, {
      filename: event?.filename,
      lineno: event?.lineno,
      stack: event?.error?.stack,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    log('error', `UI unhandledrejection: ${reason?.message || String(reason)}`, {
      stack: reason?.stack,
    });
  });

  // Breadcrumbs around message send — helps correlate black screens while responding.
  window.addEventListener('workloop:desktop-log', (event) => {
    const detail = event?.detail || {};
    log(detail.level || 'info', detail.message || 'event', detail.extra);
  });

  const origFetch = window.fetch?.bind(window);
  if (origFetch) {
    window.fetch = async (...args) => {
      const input = args[0];
      const url = typeof input === 'string' ? input : input?.url || '';
      const isMessagePost = /\/messages(\?|$)/.test(url) && String(args[1]?.method || 'GET').toUpperCase() === 'POST';
      if (isMessagePost) {
        log('info', 'Sending message (fetch POST /messages)');
      }
      try {
        const res = await origFetch(...args);
        if (isMessagePost) {
          log(res.ok ? 'info' : 'warn', `Message POST status ${res.status}`);
        }
        return res;
      } catch (err) {
        if (isMessagePost) {
          log('error', `Message POST failed: ${err?.message || err}`);
        }
        throw err;
      }
    };
  }
};
